export const {BlogActive} = global;
